import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { IonicSelectableModule } from 'ionic-selectable';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { ComponentsModule } from 'src/app/components/components.module';

import { UpdateProfilePageRoutingModule } from './update-profile-routing.module';
import { UpdateProfilePage } from './update-profile.page';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    FormsModule,
    IonicModule,
    UpdateProfilePageRoutingModule,
    ReactiveFormsModule,
    NzAutocompleteModule,
    IonicSelectableModule,
    TranslateModule,
  ],
  declarations: [UpdateProfilePage],
})
export class UpdateProfilePageModule {}
